import React, { useMemo } from 'react';
import { useZunelo } from '../../context/ZuneloContext';
import { JIRA_AXES, sortRecentAttentionItems } from '../../domain/filtering';
import { defaultAxisFilterState, filterByAxes } from '../../domain/multiAxisFiltering';
import { FilterButton } from '../../ui/common/FilterButton';
import { JiraCard } from './JiraCard';
import { SourceFeedState } from '../sources/SourceFeedState';
import { SourceGate } from '../sources/SourceGate';

export const JiraView: React.FC = () => {
  const {
    items,
    activeAxisFilters,
    setActiveAxisFilters,
    selectedId,
    loadingSources,
    errors,
    retry,
  } = useZunelo();

  const sourceItems = useMemo(
    () => sortRecentAttentionItems(items.filter((i) => i.source === 'jira')),
    [items],
  );
  const currentFilters = activeAxisFilters['jira'] || defaultAxisFilterState(JIRA_AXES);
  const isLoading = loadingSources.jira && sourceItems.length === 0;

  const filteredItems = useMemo(
    () => filterByAxes(sourceItems, JIRA_AXES, currentFilters),
    [sourceItems, currentFilters],
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
      }}
    >
      <SourceGate
        source="jira"
        error={errors.jira}
        isLoading={isLoading}
        totalCount={sourceItems.length}
        isRetrying={loadingSources.jira}
        onRetry={() => retry('jira')}
      >
        <FilterButton
          axes={JIRA_AXES}
          items={sourceItems}
          value={currentFilters}
          onChange={(next) => setActiveAxisFilters('jira', next)}
        />

        <SourceFeedState
          source="jira"
          error={errors.jira}
          isLoading={isLoading}
          isRetrying={loadingSources.jira}
          onRetry={() => retry('jira')}
          totalCount={sourceItems.length}
          visibleCount={filteredItems.length}
          onShowAll={() => setActiveAxisFilters('jira', defaultAxisFilterState(JIRA_AXES))}
        >
          {filteredItems.map((item) => (
            <JiraCard key={item.id} item={item} isSelected={selectedId === item.id} />
          ))}
        </SourceFeedState>
      </SourceGate>
    </div>
  );
};
